import { CustomizedTypography } from '@components/Customized';
import { Box, Grid, IconButton, makeStyles } from '@material-ui/core';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { colorSet } from '@components/Provider';
import { routes } from './MobileTopAppBarMenu';

export default function MobileTopNavbarPresenter() {
  const history = useHistory();
  const classes = useStyles();
  const { pathname } = useLocation();

  const currentRoute = routes.filter((item) => item.url === pathname)[0];

  return (
    <Box className={classes.root}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={5}>
          <IconButton
            onClick={() => {
              history.push('/mypage');
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
        </Grid>
        <Grid item xs={7}>
          <CustomizedTypography className={classes.subHeaderTitle}>
            {currentRoute?.menu}
          </CustomizedTypography>
        </Grid>
      </Grid>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    width: '100%',
    borderBottom: `1px solid ${colorSet.gray400}`,
    backgroundColor: 'white',
    zIndex: 2
  },
  subHeaderTitle: {
    ...theme.typography.body1,
    fontWeight: 500,
    color: colorSet.gray900
  }
}));
